<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<ptl-edit-quiz-question
  *ngIf="questionFormVisible"
  class="question-edit-container"
  [isEditingQuestion]="isEditingQuestion"
  [isQuiz]="isQuiz"
  [languageCode]="languageCode"
  [editableQuestion]="editableQuestion"
  [questionTypes]="questionTypes"
  [currentLanguage]="currentLanguage"
  (feedbackCleared)="onFeedBackClear($event)"
  (closeForm)="toggleQuestionForm()"
  (addedQuestion)="addQuestion($event)"
  (updatedQuestion)="updateQuestion($event)"
></ptl-edit-quiz-question>

<ptl-questions-quiz-list
  #tableList
  class="questions-list"
  *ngIf="formattedQuestions"
  [isQuiz]="isQuiz"
  [isDefaultLanguage]="currentLanguage?.isDefault"
  [tableData]="formattedQuestions"
  (moveItems)="onItemsMove($event)"
  (removeItem)="onItemRemove($event)"
  (editIndex)="onIndexEdit($event)"
  (copyQuestion)="onQuestionCopy($event)"
></ptl-questions-quiz-list>

<button mat-button class="add-question-button" title="Add Question" *ngIf="currentLanguage?.isDefault" (click)="toggleQuestionForm()">
  <svg class="svg svg-icon icon-left" aria-hidden="true">
    <use ogSvgUnify="assets/sprite/sprite.svg#plus"></use>
  </svg>
  <span class="small">{{ 'translations.addQuestion' | transloco }}</span>
</button>
